import { cn } from '@polyai/ui/utils';

type AccountAbbreviationProps = {
  abbreviation: string;
  isActive?: boolean;
  size?: 'sm' | 'md';
  className?: string;
};

const sizeStyles = {
  sm: 'w-[28px] h-[28px] text-[10px]',
  md: 'w-[40px] h-[40px] text-body-small',
};

export const AccountAbbreviation = ({
  abbreviation,
  isActive = false,
  size = 'md',
  className,
}: AccountAbbreviationProps) => (
  <span
    className={cn(
      'flex shrink-0 items-center justify-center rounded-xSmall',
      sizeStyles[size],
      isActive
        ? 'border-transparent bg-background-accent-strong text-primary'
        : 'border border-border-strong bg-transparent text-secondary',
      className,
    )}
  >
    {abbreviation}
  </span>
);
